"use client";
import React, { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faTimes,
  faCaretRight,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import LogoElement from "../../Element_Components/logo/logoElement";
import { useRouter } from "next/navigation";
import { fetchNavigationMenuTree } from "@/utils/buildMenuTree";
import dataLoader from "@/utils/fetchSingleType";
import { usePathname } from "next/navigation";
import ResponsiveNavLink from "./mobileNavLink";
import DesktopNavLink from "./desktopNavLink";
import SearchBar from "./searchBar";
import { collectionLoader } from "@/utils/fetchCollection";
import { useLanguage } from "@/app/LanguageContext";
import Link from "next/link";
import { getBaseUrl } from "@/lib/getBaseURL";
// import { useLanguage } from "@/app/LanguageContext";
// interface SubLink {
//   title: string;
//   path: string;
// }

interface NavLink {
  title: string;
  path: string;
  additionalFields: Record<string, any>;
  items: SubLink[];
}

interface SubLink {  
  title: string;
  path: string;
  additionalFields: Record<string, any>;
}

interface siteInfo {
  navLogo :{
    url: string;
  }
}
const ResponsiveNavbar = () => {
  const { language, setLanguage } = useLanguage();
  const [links, setLinks] = useState<NavLink[]>([]);
  const [isOpen, setIsOpen] = useState(false);
  const mobileMenuRef = useRef<HTMLDivElement>(null);
  const [logo, setLogo] = useState<siteInfo>({ navLogo: { url: "" } });

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setIsOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const response = await dataLoader<siteInfo>('site-info',language);
      setLogo(response);
    }
    fetchData();
  },[]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  useEffect(() => {
    // const fetchNavLinks = async () => {
    //   const dataNav = await fetch(
    //   );
    //   const data = await collectionLoader<NavLink>(
    //     "navigation/render/navigation"
    //   );
    //   console.log(` nav fetch response ${data}`);
    // };
    // fetchNavLinks();
    fetchNavigationMenuTree(language)
      .then((data) => {
        //  console.log('Fetched navigation menu:', data);
        //  console.log('Fetched navigation menu:', data);
        const result = data as NavLink[];
        console.log("Fetched navigation menu nav updated:", result);
        setLinks(result);
      })
      .catch((error) => {
        console.error("Error fetching navigation menu:", error);
      });
  }, []);

  return (
    <nav
      className={`bg-white flex justify-center items-center w-screen border-b h-full relative`}
    >
      <div
        className={`w-full md:w-[71rem] mx-auto flex items-center justify-between h-16 bg-white z-30 px-5 xl:px-0 `}
      >
        <div className="flex justify-center items-center space-x-2">
          <Link href="/" className="flex items-center md:items-start justify-end md:justify-start mx-auto w-full">
            <img src={`${process.env.NEXT_PUBLIC_STRAPI_URL}${logo?.navLogo?.url}`} alt="" className=" w-[15.5rem] flex items-center justify-center text-center" />
          </Link>
        </div>

        {/* Desktop Navigation - Kept exactly as your original */}
        <div className="hidden xl:flex items-start ml-auto">
          <div className="flex items-center space-x-3">
            {links.map((link) => (
              <DesktopNavLink key={link.title} link={link} />
            ))}
          </div>
          <div className="ml-4">
            <SearchBar />
          </div>
        </div>

        {/* Mobile menu button */}
        <div className="flex xl:hidden">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-gray-900 hover:bg-gray-100 focus:outline-none"
            aria-expanded={isOpen ? "true" : "false"}
          >
            <span className="sr-only">Open main menu</span>
            {!isOpen && <FontAwesomeIcon icon={faBars} className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {/* Mobile menu with overlay - Improved version */}
      {isOpen && (
        <>
          <div
            className="fixed inset-0 bg-black opacity-20 z-40"
            onClick={() => setIsOpen(false)}
          ></div>
          <div
            ref={mobileMenuRef}
            className="fixed top-12 right-1  bg-white shadow-lg z-1010 overflow-y-auto transition-all duration-300 ease-in-out max-w-screen  md:w-1/3"
          >
            <div className="px-4 py-3 space-y-2 ">
              <div className="mb-4 pt-2">
                <SearchBar />
              </div>
              <div className="space-y-1">
                {links.map((link) => (
                  <ResponsiveNavLink
                    key={link.additionalFields.view}
                    link={link}
                  />
                ))}
              </div>
            </div>
          </div>
        </>
      )}
    </nav>
  );
};

export default ResponsiveNavbar;

